import React, { useState } from 'react';

import emailjs from 'emailjs-com';
import { useHistory } from 'react-router-dom';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: '',
    });

    const history = useHistory();

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    const isEmailValid = (email) => {
        // E-posta adresi için geçerli bir düzenli ifade (RegExp) kullanalım
        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        return emailPattern.test(email);
    };
    const sendEmail = (e) => {
        e.preventDefault();
    
        const serviceID = 'service_x7bjc6g';
        const templateID = 'template_crpre6n';
        const userID = 'PU_VZTYbelxyHwbfw';
    
        const templateParams = {
            to_name: formData.name,
            from_name: formData.email,
            message: formData.message,
            phone: formData.phone,
            // diğer form verilerini burada ekleyebilirsiniz
        };
    
        if (!isEmailValid(formData.email)) {
            console.error('Geçerli bir e-posta adresi giriniz.');
            return;
        }
    
        // Show a confirmation dialog to the user
        const confirmation = window.confirm('E-posta göndermek istediğinize emin misiniz?');
    
        if (confirmation) {
            // User confirmed, proceed with sending the email
            emailjs
                .send(serviceID, templateID, templateParams, userID)
                .then((response) => {
                    console.log('E-posta başarıyla gönderildi:', response);
    
                    // E-posta gönderildikten sonra ana sayfaya yönlendir
                    history.push('/');
    
                    // Sayfayı en üstüne kaydır
                    window.scrollTo(0, 0);
    
                    // Form verilerini sıfırla
                    setFormData({
                        name: '',
                        email: '',
                        phone: '',
                        message: '',
                    });
                })
                .catch((error) => {
                    console.error('E-posta gönderme hatası:', error);
                });
        }
    };
    


    return (
        <section className="position-relative">
                    <img src="./../images/sdad.png" className="images__wrap-contact" alt="" />
                    <div className="wrapper__bg-orange-wrap"></div>
                    <div className="container position-relative z-2">
                        <div className="row">
                            <div className="col-md-6 mb-4 my-md-auto">
                                <p className="semi-bold font__size--14 text__14-1024 color__white text-uppercase">İletişim</p>
                                <h3 className="bold font__size--58 text__50-1024 text__50-sm text__50-xs color__white text-uppercase mb-4">Daha fazla bilgi almak için iletişime geçin.</h3>
                                <p className="roboto normal font__size--16 text__16-1024 color__white mb-5">İstek, öneri, şikayet ve bilgi almak için iletişime geçin.</p>

                                <div className="mb-5">
                                    <h5 className='semi-bold font__size--14 text__14-1024 color__white text-uppercase mb-3'>İletişim</h5>

                                    <div className="d-flex align-items-center">
                                        <img src="./../images/gfd (1).png" alt="" />
                                        <span className='ml-2 semi-bold font__size--14 text__14-1024 color__white text-uppercase'>info@eymentelcit.com.tr</span>
                                    </div>

                                    <div className="d-flex align-items-center my-3">
                                        <img src="./../images/gfd (6).png" alt="" />
                                        <span className='ml-2 semi-bold font__size--14 text__14-1024 color__white text-uppercase'>+90 543 624 10 88</span>
                                    </div>

                                    <div className="d-flex align-items-center">
                                        <img src="./../images/gfd (5).png" alt="" />
                                        <span className='ml-2 semi-bold font__size--14 text__14-1024 color__white text-uppercase'>Demirci Mah. Ahıska Cad. No:197 Nilüfer\ BURSA</span>
                                    </div>
                                </div>

                                <h5 className='semi-bold font__size--14 text__14-1024 color__white text-uppercase mb-3'>Bizi sosyal medyadan takip edin.</h5>

                                <div className="d-flex align-items-center">
                                    <a href="https://www.facebook.com/eymentelcit/">
                                        <img src="./../images/gfd (4).png" alt="" />
                                    </a>
                                    <a href="https://www.instagram.com/eymentel_cit_sistemleri/" className='mx-3'>
                                        <img src="./../images/gfd (3).png" alt="" />
                                    </a>
                                    <a href="https://api.whatsapp.com/send/?phone=905436241088&text=Merhabalar&type=phone_number&app_absent=0">
                                        <img src="./../images/gfd (2).png" alt="" />
                                    </a>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-5 offset-xl-1">
                                <div className="wrapper__form-contact bg__white">
                                    <h3 className="bold font__size--32 text__32-1024 color__black text-uppercase mb-4">Mail</h3>
                                    <div className="form-group">
                                        <label className="semi-bold font__size--14 text__14-1024 text-uppercase">Adınız</label>
                                        <input
                                            type="text"
                                            className="form-control wrapper__field"
                                            placeholder="Adınız..."
                                            name="name"
                                            value={formData.name}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="semi-bold font__size--14 text__14-1024 text-uppercase">Mail Adresiniz</label>
                                        <input
                                            type="email"
                                            className="form-control wrapper__field"
                                            placeholder="Mail adresiniz..."
                                            name="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="semi-bold font__size--14 text__14-1024 text-uppercase">Telefon</label>
                                        <input
                                            type="phone"
                                            className="form-control wrapper__field"
                                            placeholder="Telefon..."
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="semi-bold font__size--14 text__14-1024 text-uppercase">Mesajınız</label>
                                        <input
                                            type="text"
                                            className="form-control wrapper__field"
                                            placeholder="Mesajınız..."
                                            name="message"
                                            value={formData.message}
                                            onChange={handleInputChange}
                                            href="#"
                                        />
                                    </div>
                                    {/* Diğer form alanları buraya eklenir */}
                                    <button
                                        className="semi-bold rounded-0 font__size--14 text__14-1024 btn btn__orange shadow color__white text-uppercase"
                                        onClick={sendEmail}
                                        type="submit"
                                    >
                                        Gönder

                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
    )
}

export default Contact